export function getInputValue(showCalculatedValue: boolean, isControlled: boolean, value: string) {
  return isControlled || showCalculatedValue ? value : '-'
}
